module.exports = __webpack_public_path__ + "static/assets/97d2baf98ebb810f1afbcb94a27cf07d.svg";